import { AddUpdaterVersionRequest } from './../../models/ss-api/requests/add.updater.version.request';
import { UpdateUpdaterVersionRequest } from './../../models/ss-api/requests/update.updater.version.request';
import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { UpdaterVersionItem } from '../../models/domain/updater.version.item';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface IUpdateUpdaterVersionTemplate {
    Title: string;
    Version?: UpdaterVersionItem;
}

@Component({
    selector: 'update-updater-dialog',
    styleUrls: ['./update.updater.dialog.scss'],
    templateUrl: './update.updater.dialog.html'
})

export class UpdateUpdaterDialog extends DialogComponent<IUpdateUpdaterVersionTemplate, boolean> implements IUpdateUpdaterVersionTemplate, OnInit {
    IsBusy: boolean;
    Title: string;
    Version: UpdaterVersionItem;

    VersionForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        if (!this.Version) {
            this.Version = new UpdaterVersionItem();
        }

        this.VersionForm = new FormGroup({
            'VersionName': new FormControl(this.Version.Version, [Validators.required]),
            'Name': new FormControl(this.Version.Name, [Validators.required]),
            'Description': new FormControl(this.Version.Description, [Validators.required]),
            'DownloadURL': new FormControl(this.Version.DownloadURL, [Validators.required]),
            'IsAvailable': new FormControl(this.Version.IsAvailable, [Validators.required]),
        });
    }

    FilterNumbers(event) {
        this.Version.VersionInt = Number(event.target.value.replace(/\D/g, ''));
    }

    DeleteVersion() {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This action cannot be reversed.',
            showCancelButton: true,
            preConfirm: (response) => {
                // return api promise
                return this.api.DeleteUpdaterVersion(this.Version.ID).toPromise();
            }
        }).then((res) => {
            if (res.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Deleted Successfully',
                    text: 'Updater version has been deleted without any errors',
                    timer: 1500
                }).then(() => {
                    this.result = true;
                    this.close();
                }, () => {
                    this.result = true;
                    this.close();
                });
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: res.Message
                }).then(() => { }, () => { });
            }
        }, () => { });
    }

    confirm() {
        this.IsBusy = true;

        if (!this.VersionForm.valid) return false;

        let controls = this.VersionForm.controls;

        if (!this.Version.ID) {
            let request: AddUpdaterVersionRequest = {
                VersionNumber: controls['VersionName'].value,
                Name: controls['Name'].value,
                Description: controls['Description'].value,
                IsAvailable: controls['IsAvailable'].value,
                DownloadURL: controls['DownloadURL'].value
            };

            let disposable = this.api.AddUpdaterVersion(request).subscribe(response => {
                if (response.Result) {
                    this.result = true;
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } );
                }
                disposable.unsubscribe();
            });
        } else {
            let request: UpdateUpdaterVersionRequest = {
                UpdaterVersionID: this.Version.ID,
                VersionNumber: controls['VersionName'].value,
                Name: controls['Name'].value,
                Description: controls['Description'].value,
                IsAvailable: controls['IsAvailable'].value,
                DownloadURL: controls['DownloadURL'].value
            };


            let disposable = this.api.UpdateUpdaterVersion(request).subscribe(response => {
                if (response.Result) {
                    this.result = true;
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success!',
                        timer: 1500
                    }).then( () => { this.close(); }, () => { this.close(); } );
                }
                disposable.unsubscribe();
            });
        }
    }

}
